import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Link from 'flarum/common/components/Link';

export interface IAcceptTermsModalAttrs extends IInternalModalAttrs {
  onsubmit: () => void;
}

export default class AcceptTermsModal<CustomAttrs extends IAcceptTermsModalAttrs = IAcceptTermsModalAttrs> extends Modal<CustomAttrs> {
  protected isRead = false;

  className(): string {
    return 'Modal--small AcceptTermsModal';
  }

  title() {
    return app.translator.trans('floxum-payments.forum.accept-terms-modal.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <Switch onchange={(value: boolean) => (this.isRead = value)} state={this.isRead}>
              {app.translator.trans('floxum-payments.forum.accept-terms-modal.accept_label', {
                link: <Link href={app.forum.attribute<string>('blomstra-payments.link-to-terms')} />,
              })}
            </Switch>
          </div>
          <div className="Form-group">
            <Button className="Button Button--block Button--primary" type="submit" loading={this.loading} disabled={!this.isRead}>
              {app.translator.trans('floxum-payments.forum.accept-terms-modal.continue_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e: SubmitEvent) {
    e.preventDefault();

    super.onsubmit(e);

    this.loading = true;
    this.attrs.onsubmit();
  }
}
